import React from 'react'
import {findDOMNode} from "react-dom"

import HintPopover from "../hint-popover/hint-popover"
import SelectParent_ValueSingle from "./components/value/single/single-value"
import {QuickAddItemType} from "../../../app/quick-add/@types"
import SelectParent_Popover from "./components/popover/popover"
import {SelectParent_Props} from "./@types"
import PopoverV2 from "../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../gd-components/gd-popover/popover-position"
import {ITreeSelectorParent} from "./components/tree-new/project-tree-new";
import {EntityType} from "../../gd/const/item";

type Props = SelectParent_Props & {
    projectId?                  : ID | null
}

type State = {
    value       : ID | null

    showPopover : boolean
}

export default class SelectParentNew extends React.Component<Props, State> implements ITreeSelectorParent {

    static defaultProps = {
        placeholder                 : "Select parent",

        canBeNull                   : false,
    }

    constructor(props: Props) {
        super(props);

        this.state = {
            value               : props.projectId || null,
            showPopover         : false,
        };
    }

    // Interface method
    get parentsFor():EntityType {
        return this.props.parentsFor
    }

    get value() : ID | null {
        return this.state.value
    }

    get multiselect():boolean {
        return false
    }

    get selectedProjects():ID[] {
        return this.value ? [this.value] : []
    }

    showPopover = (e: React.SyntheticEvent) => {
        if (this.props.disabled) return;

        e.stopPropagation();
        if (!this.state.showPopover) this.setState({showPopover: true},()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(true);
        })
    };

    hidePopover = () => {
        if (this.state.showPopover) this.setState({showPopover: false},()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(false);
        })
    };

    onParentSelected = (value: ID | null) => {

        this.setState(
            {
                value               : value,
            }, ()=> {

                this.props.onChange?.(value)
                // if(this.props.onChange) this.props.onChange(value);
            }
        )

        this.hidePopover()
    }

    // used when company has no projects
    onNewProjectClick = (e: React.SyntheticEvent) => {
        e.stopPropagation()

        this.props.onAddProjectClick?.()

        this.hidePopover()

        gd.openNew(QuickAddItemType.PROJECT)
    }

    render() {
        const classes = Classes('gd-select-parent', this.props.className, 'render-'+this.props.renderType, {
            'not-selected'          : !this.state.value,
            'disabled'              : this.props.disabled,
            'open'                  : this.state.showPopover,
            'show-popover'          : this.state.showPopover, // required for inline-editable design
        })

        const popoverPosition : PopoverPosition = this.props.popoverPosition || PopoverPosition.bottomCenter() // bottomLeftHorizontal
        const showHint = this.props.hint && !this.state.showPopover

        return (
            <div className={classes} style={this.props.style}>
                <SelectParent_ValueSingle parent={this}/>

                {this.state.showPopover &&
                    <PopoverV2  position                = {popoverPosition}
                                className               = "cursor-default border-box"
                                popoverClass            = "gd-select-parent-popover-new"
                                getTargetFunc           = {()=>findDOMNode(this)}
                                outsideClickIgnoreClass = "option"
                                onClickOutside          = {this.hidePopover}>
                        <SelectParent_Popover parentSelector    = {this}
                                              onParentSelected  = {this.onParentSelected}/>
                    </PopoverV2>}

                {showHint &&
                    <HintPopover hint={this.props.hint}/>}
            </div>
        )
    }
}
